export default "__VITE_ASSET__XSqmfHo4__"